import React, { useEffect, useState } from 'react';
import { useNavigate }                 from 'react-router-dom';
import { fetchLexApps }                from './firebaseService';
import AppCard                         from './AppCard';
import AddAppModal                     from './AddAppModal';
import styles                          from './lexapp.module.css';

export default function AppList() {
  const [apps, setApps]         = useState([]);
  const [loading, setLoading]   = useState(true);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  // Fetch all public apps
  const loadApps = async () => {
    setLoading(true);
    try {
      const data = await fetchLexApps();
      setApps(data.filter(app => app.visibility === 'public'));
    } catch (err) {
      console.error('Error loading apps:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadApps();
  }, []);

  if (loading) return <p>Loading LEX apps…</p>;

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className={`${styles.lexButton_lexApp} ${styles.lexButtonPrimary_lexApp}`}
        style={{ marginBottom: '1rem' }}
      >
        + Add App
      </button>

      <div className={styles.lexGrid_lexApp}>
        {apps.map(app => (
          <div
            key={app.appId}
            onClick={() => navigate(`/lexapp/${app.appId}`)}
            style={{ cursor: 'pointer' }}
          >
            <AppCard app={app} />
          </div>
        ))}
      </div>

      {showModal && (
        <AddAppModal
          onClose={() => setShowModal(false)}
          onAdded={() => {
            setShowModal(false);
            loadApps();
          }}
        />
      )}
    </>
  );
}
